import BaseRepositoryClass from 'api/utils/BaseRepositoryClass';
import { RepositoryType, } from 'api/utils/RepositoryTypes';

export interface CheckoutTermsType {
    title: string,
    content: string,
}

class CheckoutComplete extends BaseRepositoryClass implements RepositoryType {
    update(token: string) {
        return this
            .requester
            .put<Array<CheckoutTermsType>>(`${this.apiVersion}/checkout/${token}/complete`);
    }
}

export default CheckoutComplete;
